import React from 'react';
import A from '../../Anchor/Anchor';
import { FaTwitter, FaFacebookF, FaInstagram } from 'react-icons/fa';

import './BottomFooter.scss';
import { LogoX } from '../../Icons/LogoX';
import { ImageDispatcher } from '../../ImageDispatcher/ImageDispatcher';

const BottomFooter = ({ primaryColor, datiFarmacia }) => {
  return (
    <div className="bottom-footer" style={{ backgroundColor: primaryColor }}>
      <div className="container">
        <div className="copy-social">
          {!!datiFarmacia && datiFarmacia.siteName !== 'farmaciabianca.it' && (
            <div className="copy-footer">
              <A
                href="https://www.farmakom.it/ecommerce-farmacie/"
                target="_blank"
              >
                © Ecommerce Farmacie
              </A>
              <A href="https://www.farmakom.it/" target="_blank">
                <ImageDispatcher
                  className="lazyload"
                  alt="Logo Farmakom"
                  src="/static/images/farmakom-logo-new-white.png"
                />
              </A>
            </div>
          )}
          <div className="social-footer">
            {(datiFarmacia.socialTwitterLink ||
              datiFarmacia.socialFacebookLink ||
              datiFarmacia.socialInstagramLink) && (
              <ul className="social">
                {datiFarmacia.socialTwitterLink && (
                  <li>
                    <A
                      href={datiFarmacia.socialTwitterLink}
                      aria-label={`Guarda il profilo Twitter di ${datiFarmacia.siteName}`}
                      target="_blank"
                    >
                      <LogoX
                        fill="#fff"
                        transform="translateY(9px) scale(0.5)"
                      />
                    </A>
                  </li>
                )}
                {datiFarmacia.socialFacebookLink && (
                  <li>
                    <A
                      href={datiFarmacia.socialFacebookLink}
                      aria-label={`Guarda il profilo Facebook di ${datiFarmacia.siteName}`}
                      target="_blank"
                    >
                      <FaFacebookF />
                    </A>
                  </li>
                )}
                {datiFarmacia.socialInstagramLink && (
                  <li>
                    <A
                      href={datiFarmacia.socialInstagramLink}
                      aria-label={`Guarda il profilo Instagram di ${datiFarmacia.siteName}`}
                      target="_blank"
                    >
                      <FaInstagram />
                    </A>
                  </li>
                )}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomFooter;
